import { MetricsMeasure } from 'src/components/fintech-ops/user-metrics/UserMetricsInterfaces';
import { BusinessReportingAggregatedResult } from './BusinessReportingInterfaces';

export enum DURATION_OPTIONS {
  QUARTERLY = 'QUARTERLY',
  MONTHLY = 'MONTHLY'
}

// Business Reporting Ticket Aggregation Constants
export const BUSINESS_REPORTING_TICKET_COLUMN_LIST = [
  'create_date_UserTimeZone_formatted', // Month
  'application_name'
];

export const BUSINESS_REPORTING_TICKET_MEASURE_COLUMN_LIST = [
  { name: 'total_tickets', operation: 'sum' },
  { name: 'resolved_tickets', operation: 'sum' },
  { name: 'sev2_tickets', operation: 'sum' },
  { name: 'sev3_tickets', operation: 'sum' },
  { name: 'sev4_tickets', operation: 'sum' },
  { name: 'sev5_tickets', operation: 'sum' },
  { name: 'sev2_time_spent', operation: 'floatSum' },
  { name: 'total_time_spent', operation: 'floatSum' }
];

export enum TICKET_STATUS {
  RESOLVED = 'Resolved'
}

// Measure columns for calculating totals across all aggregated data
export const BUSINESS_REPORTING_TOTALS_MEASURE_COLUMNS: MetricsMeasure[] = [
  { name: 'total_tickets', operation: 'sum' },
  { name: 'resolved_tickets', operation: 'sum' },
  { name: 'sev2_tickets', operation: 'sum' },
  { name: 'sev3_tickets', operation: 'sum' },
  { name: 'sev4_tickets', operation: 'sum' },
  { name: 'sev5_tickets', operation: 'sum' },
  { name: 'total_time_spent', operation: 'floatSum' }
];

// Month totals aggregation (group by month only)
export const BUSINESS_REPORTING_MONTH_TOTALS_COLUMN_LIST = ['create_date_UserTimeZone_formatted'];

// Application totals aggregation (group by application only)
export const BUSINESS_REPORTING_APPLICATION_TOTALS_COLUMN_LIST = ['application_name'];

// Factory functions for empty data structures
export const createEmptyBusinessReportingAggregatedData = (): BusinessReportingAggregatedResult => ({
  entries: [],
  totalTimeSpentSum: 0,
  totals: {
    total_tickets: 0,
    resolved_tickets: 0,
    sev2_tickets: 0,
    sev3_tickets: 0,
    sev4_tickets: 0,
    sev5_tickets: 0,
    total_time_spent: 0
  },
  monthTotals: [],
  applicationTotals: []
});

export const createEmptyChartData = () => ({
  severityChartData: [],
  severityChartXDomain: [],
  severityChartYDomain: 0,
  applicationChartData: [],
  applicationChartXDomain: [],
  applicationChartYDomain: [],
  incomingChartData: [],
  incomingChartXDomain: [],
  incomingChartYDomain: [],
  resolutionTypeCountPieData: [],
  resolutionTypeTimeSpentPieData: []
});
